"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _grid = require("@rebass/grid");
var _get = _interopRequireDefault(require("lodash/get"));
var _size = _interopRequireDefault(require("lodash/size"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = require("@gravity/button");
var _checkbox = _interopRequireDefault(require("@gravity/checkbox"));
var _heading = _interopRequireDefault(require("@gravity/heading"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _tabs = require("@gravity/tabs");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _productList = require("@nucleo/product-list");
var _section = _interopRequireDefault(require("@nucleo/section"));
var _SectionCluster = _interopRequireDefault(require("./SectionCluster"));
var _jsxFileName = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/Section.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_aa1p6ffe1() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/Section.js";
  var hash = "29246974318ba814e38efd74dbb00863c86e5b91";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/Section.js",
    statementMap: {
      "0": {
        start: {
          line: 34,
          column: 16
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 36,
          column: 70
        }
      },
      "2": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 53,
          column: 9
        }
      },
      "3": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 71,
          column: 9
        }
      },
      "4": {
        start: {
          line: 88,
          column: 23
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "5": {
        start: {
          line: 90,
          column: 24
        },
        end: {
          line: 90,
          column: 84
        }
      },
      "6": {
        start: {
          line: 94,
          column: 27
        },
        end: {
          line: 94,
          column: 63
        }
      },
      "7": {
        start: {
          line: 97,
          column: 27
        },
        end: {
          line: 97,
          column: 63
        }
      },
      "8": {
        start: {
          line: 108,
          column: 23
        },
        end: {
          line: 143,
          column: 2
        }
      },
      "9": {
        start: {
          line: 126,
          column: 31
        },
        end: {
          line: 126,
          column: 73
        }
      },
      "10": {
        start: {
          line: 127,
          column: 24
        },
        end: {
          line: 127,
          column: 73
        }
      },
      "11": {
        start: {
          line: 131,
          column: 24
        },
        end: {
          line: 131,
          column: 73
        }
      },
      "12": {
        start: {
          line: 136,
          column: 86
        },
        end: {
          line: 141,
          column: 5
        }
      },
      "13": {
        start: {
          line: 145,
          column: 26
        },
        end: {
          line: 169,
          column: 1
        }
      },
      "14": {
        start: {
          line: 160,
          column: 38
        },
        end: {
          line: 160,
          column: 75
        }
      },
      "15": {
        start: {
          line: 171,
          column: 29
        },
        end: {
          line: 176,
          column: 1
        }
      },
      "16": {
        start: {
          line: 178,
          column: 18
        },
        end: {
          line: 178,
          column: 46
        }
      },
      "17": {
        start: {
          line: 178,
          column: 25
        },
        end: {
          line: 178,
          column: 46
        }
      },
      "18": {
        start: {
          line: 183,
          column: 20
        },
        end: {
          line: 185,
          column: 1
        }
      },
      "19": {
        start: {
          line: 184,
          column: 2
        },
        end: {
          line: 184,
          column: 81
        }
      },
      "20": {
        start: {
          line: 184,
          column: 34
        },
        end: {
          line: 184,
          column: 79
        }
      },
      "21": {
        start: {
          line: 187,
          column: 31
        },
        end: {
          line: 187,
          column: 88
        }
      },
      "22": {
        start: {
          line: 187,
          column: 47
        },
        end: {
          line: 187,
          column: 88
        }
      },
      "23": {
        start: {
          line: 187,
          column: 72
        },
        end: {
          line: 187,
          column: 87
        }
      },
      "24": {
        start: {
          line: 189,
          column: 23
        },
        end: {
          line: 190,
          column: 81
        }
      },
      "25": {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 81
        }
      },
      "26": {
        start: {
          line: 190,
          column: 55
        },
        end: {
          line: 190,
          column: 80
        }
      },
      "27": {
        start: {
          line: 192,
          column: 16
        },
        end: {
          line: 374,
          column: 1
        }
      },
      "28": {
        start: {
          line: 223,
          column: 2
        },
        end: {
          line: 225,
          column: 3
        }
      },
      "29": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 16
        }
      },
      "30": {
        start: {
          line: 226,
          column: 19
        },
        end: {
          line: 226,
          column: 46
        }
      },
      "31": {
        start: {
          line: 227,
          column: 23
        },
        end: {
          line: 227,
          column: 42
        }
      },
      "32": {
        start: {
          line: 228,
          column: 36
        },
        end: {
          line: 228,
          column: 43
        }
      },
      "33": {
        start: {
          line: 233,
          column: 2
        },
        end: {
          line: 237,
          column: 3
        }
      },
      "34": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 55
        }
      },
      "35": {
        start: {
          line: 235,
          column: 9
        },
        end: {
          line: 237,
          column: 3
        }
      },
      "36": {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 50
        }
      },
      "37": {
        start: {
          line: 239,
          column: 71
        },
        end: {
          line: 239,
          column: 81
        }
      },
      "38": {
        start: {
          line: 240,
          column: 30
        },
        end: {
          line: 240,
          column: 67
        }
      },
      "39": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 244,
          column: 80
        }
      },
      "40": {
        start: {
          line: 246,
          column: 28
        },
        end: {
          line: 259,
          column: 5
        }
      },
      "41": {
        start: {
          line: 251,
          column: 10
        },
        end: {
          line: 255,
          column: 11
        }
      },
      "42": {
        start: {
          line: 260,
          column: 40
        },
        end: {
          line: 260,
          column: 63
        }
      },
      "43": {
        start: {
          line: 261,
          column: 25
        },
        end: {
          line: 261,
          column: 49
        }
      },
      "44": {
        start: {
          line: 262,
          column: 2
        },
        end: {
          line: 373,
          column: 4
        }
      },
      "45": {
        start: {
          line: 292,
          column: 16
        },
        end: {
          line: 331,
          column: 22
        }
      },
      "46": {
        start: {
          line: 376,
          column: 0
        },
        end: {
          line: 437,
          column: 2
        }
      },
      "47": {
        start: {
          line: 439,
          column: 0
        },
        end: {
          line: 473,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 36,
            column: 15
          },
          end: {
            line: 36,
            column: 16
          }
        },
        loc: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 70
          }
        },
        line: 36
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 9
          }
        },
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        },
        line: 41
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 15
          },
          end: {
            line: 90,
            column: 16
          }
        },
        loc: {
          start: {
            line: 90,
            column: 24
          },
          end: {
            line: 90,
            column: 84
          }
        },
        line: 90
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 94,
            column: 17
          },
          end: {
            line: 94,
            column: 18
          }
        },
        loc: {
          start: {
            line: 94,
            column: 27
          },
          end: {
            line: 94,
            column: 63
          }
        },
        line: 94
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 18
          }
        },
        loc: {
          start: {
            line: 97,
            column: 27
          },
          end: {
            line: 97,
            column: 63
          }
        },
        line: 97
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 126,
            column: 21
          },
          end: {
            line: 126,
            column: 22
          }
        },
        loc: {
          start: {
            line: 126,
            column: 31
          },
          end: {
            line: 126,
            column: 73
          }
        },
        line: 126
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 127,
            column: 14
          },
          end: {
            line: 127,
            column: 15
          }
        },
        loc: {
          start: {
            line: 127,
            column: 24
          },
          end: {
            line: 127,
            column: 73
          }
        },
        line: 127
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 131,
            column: 14
          },
          end: {
            line: 131,
            column: 15
          }
        },
        loc: {
          start: {
            line: 131,
            column: 24
          },
          end: {
            line: 131,
            column: 73
          }
        },
        line: 131
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 136,
            column: 7
          }
        },
        loc: {
          start: {
            line: 136,
            column: 86
          },
          end: {
            line: 141,
            column: 5
          }
        },
        line: 136
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 160,
            column: 25
          },
          end: {
            line: 160,
            column: 26
          }
        },
        loc: {
          start: {
            line: 160,
            column: 38
          },
          end: {
            line: 160,
            column: 75
          }
        },
        line: 160
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 178,
            column: 18
          },
          end: {
            line: 178,
            column: 19
          }
        },
        loc: {
          start: {
            line: 178,
            column: 25
          },
          end: {
            line: 178,
            column: 46
          }
        },
        line: 178
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 183,
            column: 20
          },
          end: {
            line: 183,
            column: 21
          }
        },
        loc: {
          start: {
            line: 183,
            column: 72
          },
          end: {
            line: 185,
            column: 1
          }
        },
        line: 183
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 184,
            column: 21
          },
          end: {
            line: 184,
            column: 22
          }
        },
        loc: {
          start: {
            line: 184,
            column: 34
          },
          end: {
            line: 184,
            column: 79
          }
        },
        line: 184
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 187,
            column: 31
          },
          end: {
            line: 187,
            column: 32
          }
        },
        loc: {
          start: {
            line: 187,
            column: 47
          },
          end: {
            line: 187,
            column: 88
          }
        },
        line: 187
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 187,
            column: 64
          },
          end: {
            line: 187,
            column: 65
          }
        },
        loc: {
          start: {
            line: 187,
            column: 72
          },
          end: {
            line: 187,
            column: 87
          }
        },
        line: 187
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 189,
            column: 23
          },
          end: {
            line: 189,
            column: 24
          }
        },
        loc: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 81
          }
        },
        line: 190
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 190,
            column: 44
          },
          end: {
            line: 190,
            column: 45
          }
        },
        loc: {
          start: {
            line: 190,
            column: 55
          },
          end: {
            line: 190,
            column: 80
          }
        },
        line: 190
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 192,
            column: 16
          },
          end: {
            line: 192,
            column: 17
          }
        },
        loc: {
          start: {
            line: 221,
            column: 6
          },
          end: {
            line: 374,
            column: 1
          }
        },
        line: 221
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 250,
            column: 30
          },
          end: {
            line: 250,
            column: 31
          }
        },
        loc: {
          start: {
            line: 251,
            column: 10
          },
          end: {
            line: 255,
            column: 11
          }
        },
        line: 251
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 291,
            column: 36
          },
          end: {
            line: 291,
            column: 37
          }
        },
        loc: {
          start: {
            line: 292,
            column: 16
          },
          end: {
            line: 331,
            column: 22
          }
        },
        line: 292
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 29
          }
        }, {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 29
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 94,
            column: 27
          },
          end: {
            line: 94,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 45
          },
          end: {
            line: 94,
            column: 51
          }
        }, {
          start: {
            line: 94,
            column: 54
          },
          end: {
            line: 94,
            column: 63
          }
        }],
        line: 94
      },
      "3": {
        loc: {
          start: {
            line: 97,
            column: 27
          },
          end: {
            line: 97,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 45
          },
          end: {
            line: 97,
            column: 51
          }
        }, {
          start: {
            line: 97,
            column: 54
          },
          end: {
            line: 97,
            column: 63
          }
        }],
        line: 97
      },
      "4": {
        loc: {
          start: {
            line: 126,
            column: 31
          },
          end: {
            line: 126,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 59
          },
          end: {
            line: 126,
            column: 64
          }
        }, {
          start: {
            line: 126,
            column: 67
          },
          end: {
            line: 126,
            column: 73
          }
        }],
        line: 126
      },
      "5": {
        loc: {
          start: {
            line: 127,
            column: 24
          },
          end: {
            line: 127,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 52
          },
          end: {
            line: 127,
            column: 61
          }
        }, {
          start: {
            line: 127,
            column: 64
          },
          end: {
            line: 127,
            column: 73
          }
        }],
        line: 127
      },
      "6": {
        loc: {
          start: {
            line: 131,
            column: 24
          },
          end: {
            line: 131,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 52
          },
          end: {
            line: 131,
            column: 61
          }
        }, {
          start: {
            line: 131,
            column: 64
          },
          end: {
            line: 131,
            column: 73
          }
        }],
        line: 131
      },
      "7": {
        loc: {
          start: {
            line: 136,
            column: 16
          },
          end: {
            line: 136,
            column: 79
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 136,
            column: 77
          },
          end: {
            line: 136,
            column: 79
          }
        }],
        line: 136
      },
      "8": {
        loc: {
          start: {
            line: 138,
            column: 20
          },
          end: {
            line: 138,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 20
          },
          end: {
            line: 138,
            column: 37
          }
        }, {
          start: {
            line: 138,
            column: 41
          },
          end: {
            line: 138,
            column: 47
          }
        }],
        line: 138
      },
      "9": {
        loc: {
          start: {
            line: 160,
            column: 38
          },
          end: {
            line: 160,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 38
          },
          end: {
            line: 160,
            column: 63
          }
        }, {
          start: {
            line: 160,
            column: 67
          },
          end: {
            line: 160,
            column: 75
          }
        }],
        line: 160
      },
      "10": {
        loc: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 9
          }
        }, {
          start: {
            line: 190,
            column: 13
          },
          end: {
            line: 190,
            column: 81
          }
        }],
        line: 190
      },
      "11": {
        loc: {
          start: {
            line: 190,
            column: 14
          },
          end: {
            line: 190,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 14
          },
          end: {
            line: 190,
            column: 30
          }
        }, {
          start: {
            line: 190,
            column: 34
          },
          end: {
            line: 190,
            column: 36
          }
        }],
        line: 190
      },
      "12": {
        loc: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 225,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 225,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 223
      },
      "13": {
        loc: {
          start: {
            line: 228,
            column: 22
          },
          end: {
            line: 228,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 228,
            column: 29
          },
          end: {
            line: 228,
            column: 31
          }
        }],
        line: 228
      },
      "14": {
        loc: {
          start: {
            line: 233,
            column: 2
          },
          end: {
            line: 237,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 2
          },
          end: {
            line: 237,
            column: 3
          }
        }, {
          start: {
            line: 235,
            column: 9
          },
          end: {
            line: 237,
            column: 3
          }
        }],
        line: 233
      },
      "15": {
        loc: {
          start: {
            line: 235,
            column: 9
          },
          end: {
            line: 237,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 235,
            column: 9
          },
          end: {
            line: 237,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 235
      },
      "16": {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 244,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 32
          }
        }, {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 244,
            column: 80
          }
        }],
        line: 243
      },
      "17": {
        loc: {
          start: {
            line: 246,
            column: 28
          },
          end: {
            line: 259,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 28
          },
          end: {
            line: 246,
            column: 43
          }
        }, {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 247,
            column: 33
          }
        }, {
          start: {
            line: 248,
            column: 6
          },
          end: {
            line: 258,
            column: 8
          }
        }],
        line: 246
      },
      "18": {
        loc: {
          start: {
            line: 261,
            column: 25
          },
          end: {
            line: 261,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 25
          },
          end: {
            line: 261,
            column: 31
          }
        }, {
          start: {
            line: 261,
            column: 35
          },
          end: {
            line: 261,
            column: 49
          }
        }],
        line: 261
      },
      "19": {
        loc: {
          start: {
            line: 264,
            column: 38
          },
          end: {
            line: 264,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 38
          },
          end: {
            line: 264,
            column: 44
          }
        }, {
          start: {
            line: 264,
            column: 48
          },
          end: {
            line: 264,
            column: 62
          }
        }],
        line: 264
      },
      "20": {
        loc: {
          start: {
            line: 267,
            column: 7
          },
          end: {
            line: 270,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 267,
            column: 7
          },
          end: {
            line: 267,
            column: 22
          }
        }, {
          start: {
            line: 268,
            column: 8
          },
          end: {
            line: 268,
            column: 37
          }
        }, {
          start: {
            line: 269,
            column: 10
          },
          end: {
            line: 269,
            column: 74
          }
        }],
        line: 267
      },
      "21": {
        loc: {
          start: {
            line: 278,
            column: 9
          },
          end: {
            line: 278,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 278,
            column: 29
          },
          end: {
            line: 278,
            column: 76
          }
        }, {
          start: {
            line: 278,
            column: 79
          },
          end: {
            line: 278,
            column: 91
          }
        }],
        line: 278
      },
      "22": {
        loc: {
          start: {
            line: 279,
            column: 9
          },
          end: {
            line: 283,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 279,
            column: 9
          },
          end: {
            line: 279,
            column: 19
          }
        }, {
          start: {
            line: 280,
            column: 10
          },
          end: {
            line: 282,
            column: 30
          }
        }],
        line: 279
      },
      "23": {
        loc: {
          start: {
            line: 281,
            column: 28
          },
          end: {
            line: 281,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 281,
            column: 40
          },
          end: {
            line: 281,
            column: 54
          }
        }, {
          start: {
            line: 281,
            column: 57
          },
          end: {
            line: 281,
            column: 69
          }
        }],
        line: 281
      },
      "24": {
        loc: {
          start: {
            line: 285,
            column: 7
          },
          end: {
            line: 371,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 7
          },
          end: {
            line: 285,
            column: 17
          }
        }, {
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 370,
            column: 25
          }
        }],
        line: 285
      },
      "25": {
        loc: {
          start: {
            line: 287,
            column: 11
          },
          end: {
            line: 334,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 287,
            column: 11
          },
          end: {
            line: 287,
            column: 19
          }
        }, {
          start: {
            line: 288,
            column: 12
          },
          end: {
            line: 333,
            column: 19
          }
        }],
        line: 287
      },
      "26": {
        loc: {
          start: {
            line: 295,
            column: 20
          },
          end: {
            line: 299,
            column: 21
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 296,
            column: 22
          },
          end: {
            line: 296,
            column: 89
          }
        }, {
          start: {
            line: 298,
            column: 22
          },
          end: {
            line: 298,
            column: 34
          }
        }],
        line: 295
      },
      "27": {
        loc: {
          start: {
            line: 304,
            column: 29
          },
          end: {
            line: 304,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 29
          },
          end: {
            line: 304,
            column: 36
          }
        }, {
          start: {
            line: 304,
            column: 40
          },
          end: {
            line: 304,
            column: 55
          }
        }],
        line: 304
      },
      "28": {
        loc: {
          start: {
            line: 305,
            column: 33
          },
          end: {
            line: 305,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 33
          },
          end: {
            line: 305,
            column: 44
          }
        }, {
          start: {
            line: 305,
            column: 48
          },
          end: {
            line: 305,
            column: 67
          }
        }],
        line: 305
      },
      "29": {
        loc: {
          start: {
            line: 306,
            column: 33
          },
          end: {
            line: 306,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 33
          },
          end: {
            line: 306,
            column: 44
          }
        }, {
          start: {
            line: 306,
            column: 48
          },
          end: {
            line: 306,
            column: 67
          }
        }],
        line: 306
      },
      "30": {
        loc: {
          start: {
            line: 307,
            column: 33
          },
          end: {
            line: 307,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 33
          },
          end: {
            line: 307,
            column: 44
          }
        }, {
          start: {
            line: 307,
            column: 48
          },
          end: {
            line: 307,
            column: 67
          }
        }],
        line: 307
      },
      "31": {
        loc: {
          start: {
            line: 308,
            column: 37
          },
          end: {
            line: 308,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 308,
            column: 37
          },
          end: {
            line: 308,
            column: 58
          }
        }, {
          start: {
            line: 308,
            column: 62
          },
          end: {
            line: 308,
            column: 82
          }
        }],
        line: 308
      },
      "32": {
        loc: {
          start: {
            line: 311,
            column: 37
          },
          end: {
            line: 311,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 311,
            column: 37
          },
          end: {
            line: 311,
            column: 55
          }
        }, {
          start: {
            line: 311,
            column: 59
          },
          end: {
            line: 311,
            column: 85
          }
        }],
        line: 311
      },
      "33": {
        loc: {
          start: {
            line: 312,
            column: 31
          },
          end: {
            line: 312,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 312,
            column: 31
          },
          end: {
            line: 312,
            column: 47
          }
        }, {
          start: {
            line: 312,
            column: 51
          },
          end: {
            line: 312,
            column: 75
          }
        }],
        line: 312
      },
      "34": {
        loc: {
          start: {
            line: 313,
            column: 38
          },
          end: {
            line: 313,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 313,
            column: 38
          },
          end: {
            line: 313,
            column: 54
          }
        }, {
          start: {
            line: 313,
            column: 58
          },
          end: {
            line: 313,
            column: 82
          }
        }],
        line: 313
      },
      "35": {
        loc: {
          start: {
            line: 335,
            column: 11
          },
          end: {
            line: 369,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 335,
            column: 11
          },
          end: {
            line: 335,
            column: 20
          }
        }, {
          start: {
            line: 336,
            column: 12
          },
          end: {
            line: 336,
            column: 24
          }
        }, {
          start: {
            line: 337,
            column: 14
          },
          end: {
            line: 368,
            column: 16
          }
        }],
        line: 335
      },
      "36": {
        loc: {
          start: {
            line: 339,
            column: 24
          },
          end: {
            line: 339,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 339,
            column: 24
          },
          end: {
            line: 339,
            column: 30
          }
        }, {
          start: {
            line: 339,
            column: 34
          },
          end: {
            line: 339,
            column: 48
          }
        }],
        line: 339
      },
      "37": {
        loc: {
          start: {
            line: 340,
            column: 25
          },
          end: {
            line: 340,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 340,
            column: 25
          },
          end: {
            line: 340,
            column: 32
          }
        }, {
          start: {
            line: 340,
            column: 36
          },
          end: {
            line: 340,
            column: 51
          }
        }],
        line: 340
      },
      "38": {
        loc: {
          start: {
            line: 341,
            column: 29
          },
          end: {
            line: 341,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 341,
            column: 29
          },
          end: {
            line: 341,
            column: 40
          }
        }, {
          start: {
            line: 341,
            column: 44
          },
          end: {
            line: 341,
            column: 63
          }
        }],
        line: 341
      },
      "39": {
        loc: {
          start: {
            line: 342,
            column: 29
          },
          end: {
            line: 342,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 342,
            column: 29
          },
          end: {
            line: 342,
            column: 40
          }
        }, {
          start: {
            line: 342,
            column: 44
          },
          end: {
            line: 342,
            column: 63
          }
        }],
        line: 342
      },
      "40": {
        loc: {
          start: {
            line: 343,
            column: 29
          },
          end: {
            line: 343,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 343,
            column: 29
          },
          end: {
            line: 343,
            column: 40
          }
        }, {
          start: {
            line: 343,
            column: 44
          },
          end: {
            line: 343,
            column: 63
          }
        }],
        line: 343
      },
      "41": {
        loc: {
          start: {
            line: 344,
            column: 32
          },
          end: {
            line: 344,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 344,
            column: 32
          },
          end: {
            line: 344,
            column: 46
          }
        }, {
          start: {
            line: 344,
            column: 50
          },
          end: {
            line: 344,
            column: 72
          }
        }],
        line: 344
      },
      "42": {
        loc: {
          start: {
            line: 345,
            column: 33
          },
          end: {
            line: 345,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 345,
            column: 33
          },
          end: {
            line: 345,
            column: 54
          }
        }, {
          start: {
            line: 345,
            column: 58
          },
          end: {
            line: 345,
            column: 78
          }
        }],
        line: 345
      },
      "43": {
        loc: {
          start: {
            line: 347,
            column: 33
          },
          end: {
            line: 347,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 33
          },
          end: {
            line: 347,
            column: 51
          }
        }, {
          start: {
            line: 347,
            column: 55
          },
          end: {
            line: 347,
            column: 81
          }
        }],
        line: 347
      },
      "44": {
        loc: {
          start: {
            line: 348,
            column: 27
          },
          end: {
            line: 348,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 348,
            column: 27
          },
          end: {
            line: 348,
            column: 43
          }
        }, {
          start: {
            line: 348,
            column: 47
          },
          end: {
            line: 348,
            column: 71
          }
        }],
        line: 348
      },
      "45": {
        loc: {
          start: {
            line: 349,
            column: 34
          },
          end: {
            line: 349,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 349,
            column: 34
          },
          end: {
            line: 349,
            column: 50
          }
        }, {
          start: {
            line: 349,
            column: 54
          },
          end: {
            line: 349,
            column: 78
          }
        }],
        line: 349
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "29246974318ba814e38efd74dbb00863c86e5b91"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_aa1p6ffe1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_aa1p6ffe1();
var Wrapper = (cov_aa1p6ffe1().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_aa1p6ffe1().f[0]++;
    cov_aa1p6ffe1().s[1]++;
    return "stx-Section stx-Section-".concat(props.sectionCode);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n    "])), function (props) {
  cov_aa1p6ffe1().f[1]++;
  cov_aa1p6ffe1().s[2]++;
  return (cov_aa1p6ffe1().b[0][0]++, props.isReportContext) && (cov_aa1p6ffe1().b[0][1]++, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          .stx-Section-heading {\n            width: 90%;\n            flex: 1;\n          }\n          .stx-SectionContent {\n            width: 100%;\n          }\n        "]))));
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      background: transparent;\n\n      ", ";\n\n      &.layout-SLIDER {\n        .stx-SectionCluster.showAsCarousel {\n          .stx-ProductBox {\n            .stx-ProductCard {\n              box-shadow: none;\n              padding: 0;\n              border-radius: 0;\n            }\n          }\n        }\n      }\n    "])), function (props) {
  cov_aa1p6ffe1().f[2]++;
  cov_aa1p6ffe1().s[3]++;
  return (cov_aa1p6ffe1().b[1][0]++, props.isReportContext) && (cov_aa1p6ffe1().b[1][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          .stx-Section-heading {\n            width: 90%;\n            flex: 1;\n          }\n          .stx-SectionContent {\n            width: 100%;\n          }\n        "]))));
}))));
var SectionContent = (cov_aa1p6ffe1().s[4]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_aa1p6ffe1().f[3]++;
    cov_aa1p6ffe1().s[5]++;
    return "stx-SectionContent stx-SectionContent-".concat(props.sectionCode);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      display: ", ";\n    "])), function (props) {
  cov_aa1p6ffe1().f[4]++;
  cov_aa1p6ffe1().s[6]++;
  return props.collapsed ? (cov_aa1p6ffe1().b[2][0]++, 'none') : (cov_aa1p6ffe1().b[2][1]++, 'inherit');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      display: ", ";\n      margin-top: 16px;\n      > .g-Tabs {\n        > .g-Tabs-list {\n          padding: 0;\n        }\n      }\n    "])), function (props) {
  cov_aa1p6ffe1().f[5]++;
  cov_aa1p6ffe1().s[7]++;
  return props.collapsed ? (cov_aa1p6ffe1().b[3][0]++, 'none') : (cov_aa1p6ffe1().b[3][1]++, 'inherit');
}))));
var SectionHeading = (cov_aa1p6ffe1().s[8]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_heading.default), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    margin-top: 2.5rem;\n    margin-bottom: 0.8rem;\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: normal;\n    padding: 0 1rem;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n\n    padding-right: ", ";\n    cursor: ", ";\n  "])), _stylingConstants.default.font.weightBold, _stylingConstants.default.font.sizeXl, _stylingConstants.default.font.sizeXl, function (props) {
  cov_aa1p6ffe1().f[6]++;
  cov_aa1p6ffe1().s[9]++;
  return props.onCollapse !== null ? (cov_aa1p6ffe1().b[4][0]++, '2em') : (cov_aa1p6ffe1().b[4][1]++, '1rem');
}, function (props) {
  cov_aa1p6ffe1().f[7]++;
  cov_aa1p6ffe1().s[10]++;
  return props.onCollapse !== null ? (cov_aa1p6ffe1().b[5][0]++, 'pointer') : (cov_aa1p6ffe1().b[5][1]++, 'inherit');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    user-select: none;\n    cursor: ", ";\n    margin: 0;\n    display: block;\n    font-weight: var(--boxTitleTextWeight, normal);\n\n    ", ";\n  "])), function (props) {
  cov_aa1p6ffe1().f[8]++;
  cov_aa1p6ffe1().s[11]++;
  return props.onCollapse !== null ? (cov_aa1p6ffe1().b[6][0]++, 'pointer') : (cov_aa1p6ffe1().b[6][1]++, 'inherit');
}, function (_ref) {
  var _ref$theme = _ref.theme,
    _ref$theme2 = _ref$theme === void 0 ? (cov_aa1p6ffe1().b[7][0]++, {}) : _ref$theme,
    boxTitleTextSize = _ref$theme2.boxTitleTextSize,
    boxTitleTextAlign = _ref$theme2.boxTitleTextAlign,
    boxTitleTextColor = _ref$theme2.boxTitleTextColor;
  cov_aa1p6ffe1().f[9]++;
  cov_aa1p6ffe1().s[12]++;
  return (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      color: var(--boxTitleTextColor, ", ");\n      text-align: ", ";\n      font-size: var(--boxTitleTextSize, ", ");\n      line-height: normal;\n    "])), boxTitleTextColor, (cov_aa1p6ffe1().b[8][0]++, boxTitleTextAlign) || (cov_aa1p6ffe1().b[8][1]++, 'left'), boxTitleTextSize);
}))));
var HeaderIconWrapper = (cov_aa1p6ffe1().s[13]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_grid.Box).attrs({
  className: 'stx-Section-heading-icon'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      right: 0.5rem;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      right: 0.5rem;\n      top: 0;\n      .g-Icon {\n        top: -8px;\n        border-radius: ", ";\n        border: 1px solid  var(--dividerColor, #d5d5d9);\n        width: var(--inputButtonHeight);\n        height: var(--inputButtonHeight);\n        padding: 10px;\n        color: var(--textColor, #212121);\n      }\n    "])), function (_ref2) {
  var theme = _ref2.theme;
  cov_aa1p6ffe1().f[10]++;
  cov_aa1p6ffe1().s[14]++;
  return (cov_aa1p6ffe1().b[9][0]++, theme.roundedBorderRadius) || (cov_aa1p6ffe1().b[9][1]++, '9999px');
}))));
var CheckBoxAllContainer = (cov_aa1p6ffe1().s[15]++, _styledComponents.default.div.attrs({
  className: 'stx-checkBoxAllContainer'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 2.5rem;\n  margin-bottom: 0.9rem;\n"]))));
cov_aa1p6ffe1().s[16]++;
var dasherize = function dasherize(str) {
  cov_aa1p6ffe1().f[11]++;
  cov_aa1p6ffe1().s[17]++;
  return str.replace(/ /g, '');
};
/*
 * Component to display a specific section defined in the backend
 */
cov_aa1p6ffe1().s[18]++;
var onSelectAll = function onSelectAll(productIds, onProductSelectChange, isSelectAll) {
  cov_aa1p6ffe1().f[12]++;
  cov_aa1p6ffe1().s[19]++;
  productIds.forEach(function (productId) {
    cov_aa1p6ffe1().f[13]++;
    cov_aa1p6ffe1().s[20]++;
    return onProductSelectChange(productId, isSelectAll);
  });
};
cov_aa1p6ffe1().s[21]++;
var getProductIdsOfSection = function getProductIdsOfSection(clusterItems) {
  cov_aa1p6ffe1().f[14]++;
  cov_aa1p6ffe1().s[22]++;
  return clusterItems.map(function (item) {
    cov_aa1p6ffe1().f[15]++;
    cov_aa1p6ffe1().s[23]++;
    return item.product.id;
  });
};
cov_aa1p6ffe1().s[24]++;
var isSectionEmpty = function isSectionEmpty(section) {
  cov_aa1p6ffe1().f[16]++;
  cov_aa1p6ffe1().s[25]++;
  return (cov_aa1p6ffe1().b[10][0]++, section) && (cov_aa1p6ffe1().b[10][1]++, ((cov_aa1p6ffe1().b[11][0]++, section.clusters) || (cov_aa1p6ffe1().b[11][1]++, [])).every(function (cluster) {
    cov_aa1p6ffe1().f[17]++;
    cov_aa1p6ffe1().s[26]++;
    return (0, _size.default)(cluster.items) === 0;
  }));
};
cov_aa1p6ffe1().s[27]++;
var Section = function Section(_ref3) {
  var section = _ref3.section,
    customSectionName = _ref3.customSectionName,
    aspectRatio = _ref3.aspectRatio,
    randomOrder = _ref3.randomOrder,
    columns = _ref3.columns,
    maxInSlider = _ref3.maxInSlider,
    maxItemPerPage = _ref3.maxItemPerPage,
    layout = _ref3.layout,
    waitingListEnabled = _ref3.waitingListEnabled,
    currencyCode = _ref3.currencyCode,
    isSignedIn = _ref3.isSignedIn,
    showDate = _ref3.showDate,
    showTime = _ref3.showTime,
    displayActionBtn = _ref3.displayActionBtn,
    displayPriceInfo = _ref3.displayPriceInfo,
    displayDescPreview = _ref3.displayDescPreview,
    onActionClick = _ref3.onActionClick,
    hideShowMoreButton = _ref3.hideShowMoreButton,
    onCollapse = _ref3.onCollapse,
    collapsed = _ref3.collapsed,
    reportData = _ref3.reportData,
    ecommerceGoogleTracking = _ref3.ecommerceGoogleTracking,
    isLandingPage = _ref3.isLandingPage,
    onWatchStreamOnline = _ref3.onWatchStreamOnline,
    replaceProductNameByPerformance = _ref3.replaceProductNameByPerformance,
    resaleAvailability = _ref3.resaleAvailability,
    actionButtonVariant = _ref3.actionButtonVariant,
    fullWidthActionButtonBreakpoint = _ref3.fullWidthActionButtonBreakpoint;
  cov_aa1p6ffe1().f[18]++;
  cov_aa1p6ffe1().s[28]++;
  // If section don't have any item => Not render anything
  if (isSectionEmpty(section)) {
    cov_aa1p6ffe1().b[12][0]++;
    cov_aa1p6ffe1().s[29]++;
    return null;
  } else {
    cov_aa1p6ffe1().b[12][1]++;
  }
  var showTabs = (cov_aa1p6ffe1().s[30]++, section.clusters.length > 1);
  var firstCluster = (cov_aa1p6ffe1().s[31]++, section.clusters[0]);
  var _ref4 = (cov_aa1p6ffe1().s[32]++, section),
    classifyBy = _ref4.classifyBy,
    _ref4$code = _ref4.code,
    code = _ref4$code === void 0 ? (cov_aa1p6ffe1().b[13][0]++, '') : _ref4$code;
  // If the classifyBy is date or family, the cluster are built from the products inside
  // The name of the date or the family is not accessible from the nucleo, so check here
  // if we need to get the translation
  var translationPrefix;
  cov_aa1p6ffe1().s[33]++;
  if (classifyBy === 'DATE') {
    cov_aa1p6ffe1().b[14][0]++;
    cov_aa1p6ffe1().s[34]++;
    translationPrefix = 'gravity.Section.relativeDay.';
  } else {
    cov_aa1p6ffe1().b[14][1]++;
    cov_aa1p6ffe1().s[35]++;
    if (classifyBy === 'FAMILY') {
      cov_aa1p6ffe1().b[15][0]++;
      cov_aa1p6ffe1().s[36]++;
      translationPrefix = 'gravity.Section.family.';
    } else {
      cov_aa1p6ffe1().b[15][1]++;
    }
  }
  var _ref5 = (cov_aa1p6ffe1().s[37]++, reportData),
    isReportContext = _ref5.isReportContext,
    onProductSelectChange = _ref5.onProductSelectChange,
    selectProductIds = _ref5.selectProductIds;
  var sectionClusterItems = (cov_aa1p6ffe1().s[38]++, (0, _get.default)(section, 'clusters[0].items', []));
  // SelectAll = true => Select product ids list must contain all product id of section
  var isSelectAll = (cov_aa1p6ffe1().s[39]++, (cov_aa1p6ffe1().b[16][0]++, (0, _size.default)(selectProductIds) !== 0) && (cov_aa1p6ffe1().b[16][1]++, (0, _size.default)(getProductIdsOfSection(sectionClusterItems)) === (0, _size.default)(selectProductIds)));
  // Not show checkbox when section does not have any item
  var selectAllCheckbox = (cov_aa1p6ffe1().s[40]++, (cov_aa1p6ffe1().b[17][0]++, isReportContext) && (cov_aa1p6ffe1().b[17][1]++, (0, _size.default)(sectionClusterItems) > 0) && (cov_aa1p6ffe1().b[17][2]++, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    checked: isSelectAll,
    handleCheckboxChange: function handleCheckboxChange() {
      cov_aa1p6ffe1().f[19]++;
      cov_aa1p6ffe1().s[41]++;
      return onSelectAll(getProductIdsOfSection(sectionClusterItems), onProductSelectChange, !isSelectAll);
    },
    isFullyControlledByProps: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 7
    }
  })));
  var _ref6 = (cov_aa1p6ffe1().s[42]++, ecommerceGoogleTracking),
    useGoogleEnhancedTracking = _ref6.useGoogleEnhancedTracking;
  var selectedLayout = (cov_aa1p6ffe1().s[43]++, (cov_aa1p6ffe1().b[18][0]++, layout) || (cov_aa1p6ffe1().b[18][1]++, section.layout));
  cov_aa1p6ffe1().s[44]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: (0, _utils.classNames)("layout-".concat((cov_aa1p6ffe1().b[19][0]++, layout) || (cov_aa1p6ffe1().b[19][1]++, section.layout))),
    sectionCode: code,
    isReportContext: isReportContext,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 263,
      columnNumber: 5
    }
  }, (cov_aa1p6ffe1().b[20][0]++, isReportContext) && (cov_aa1p6ffe1().b[20][1]++, (0, _size.default)(sectionClusterItems) > 0) && (cov_aa1p6ffe1().b[20][2]++, /*#__PURE__*/_react.default.createElement(CheckBoxAllContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 11
    }
  }, selectAllCheckbox)), /*#__PURE__*/_react.default.createElement(SectionHeading, {
    className: (0, _utils.classNames)("stx-SectionHeading stx-SectionHeading-".concat(code), {
      'stx-SectionHeading-collapsed': collapsed
    }),
    level: 2,
    onClick: onCollapse,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 272,
      columnNumber: 7
    }
  }, customSectionName ? (cov_aa1p6ffe1().b[21][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends2.default)({}, customSectionName, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 278,
      columnNumber: 30
    }
  }))) : (cov_aa1p6ffe1().b[21][1]++, section.name), (cov_aa1p6ffe1().b[22][0]++, onCollapse) && (cov_aa1p6ffe1().b[22][1]++, /*#__PURE__*/_react.default.createElement(HeaderIconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    iconName: collapsed ? (cov_aa1p6ffe1().b[23][0]++, 'chevron-down') : (cov_aa1p6ffe1().b[23][1]++, 'chevron-up'),
    size: "large",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 281,
      columnNumber: 13
    }
  })))), (cov_aa1p6ffe1().b[24][0]++, !collapsed) && (cov_aa1p6ffe1().b[24][1]++, /*#__PURE__*/_react.default.createElement(SectionContent, {
    sectionCode: code,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 9
    }
  }, (cov_aa1p6ffe1().b[25][0]++, showTabs) && (cov_aa1p6ffe1().b[25][1]++, /*#__PURE__*/_react.default.createElement(_tabs.Tabs, {
    useGoogleEnhancedTracking: useGoogleEnhancedTracking,
    isLandingPage: isLandingPage,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 288,
      columnNumber: 13
    }
  }, section.clusters.map(function (cluster) {
    cov_aa1p6ffe1().f[20]++;
    cov_aa1p6ffe1().s[45]++;
    return /*#__PURE__*/_react.default.createElement(_tabs.Tab, {
      key: dasherize(cluster.name),
      label: translationPrefix ? (cov_aa1p6ffe1().b[26][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "".concat(translationPrefix).concat(cluster.name),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 296,
          columnNumber: 23
        }
      })) : (cov_aa1p6ffe1().b[26][1]++, cluster.name),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 292,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement(_SectionCluster.default, {
      cluster: cluster,
      layout: selectedLayout,
      columns: (cov_aa1p6ffe1().b[27][0]++, columns) || (cov_aa1p6ffe1().b[27][1]++, section.columns),
      aspectRatio: (cov_aa1p6ffe1().b[28][0]++, aspectRatio) || (cov_aa1p6ffe1().b[28][1]++, section.aspectRatio),
      randomOrder: (cov_aa1p6ffe1().b[29][0]++, randomOrder) || (cov_aa1p6ffe1().b[29][1]++, section.randomOrder),
      maxInSlider: (cov_aa1p6ffe1().b[30][0]++, maxInSlider) || (cov_aa1p6ffe1().b[30][1]++, section.maxInSlider),
      showOccurrences: (cov_aa1p6ffe1().b[31][0]++, classifyBy === 'DATE') || (cov_aa1p6ffe1().b[31][1]++, classifyBy === 'DAY'),
      waitingListEnabled: waitingListEnabled,
      currencyCode: currencyCode,
      showDescription: (cov_aa1p6ffe1().b[32][0]++, displayDescPreview) || (cov_aa1p6ffe1().b[32][1]++, section.displayDescPreview),
      showPrice: (cov_aa1p6ffe1().b[33][0]++, displayPriceInfo) || (cov_aa1p6ffe1().b[33][1]++, section.displayPriceInfo),
      displayActionBtn: (cov_aa1p6ffe1().b[34][0]++, displayActionBtn) || (cov_aa1p6ffe1().b[34][1]++, section.displayActionBtn),
      isSignedIn: isSignedIn,
      classifyBy: classifyBy,
      showDate: showDate,
      showTime: showTime,
      sectionCode: code,
      loading: section.LOADING,
      onActionClick: onActionClick,
      hideShowMoreButton: hideShowMoreButton,
      sortByDate: section.sortByDate,
      reportData: reportData,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      isLandingPage: isLandingPage,
      onWatchStreamOnline: onWatchStreamOnline,
      replaceProductNameByPerformance: replaceProductNameByPerformance,
      resaleAvailability: resaleAvailability,
      fullWidthActionButtonBreakpoint: fullWidthActionButtonBreakpoint,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 301,
        columnNumber: 19
      }
    }));
  }))), (cov_aa1p6ffe1().b[35][0]++, !showTabs) && (cov_aa1p6ffe1().b[35][1]++, firstCluster) && (cov_aa1p6ffe1().b[35][2]++, /*#__PURE__*/_react.default.createElement(_SectionCluster.default, {
    cluster: firstCluster,
    layout: (cov_aa1p6ffe1().b[36][0]++, layout) || (cov_aa1p6ffe1().b[36][1]++, section.layout),
    columns: (cov_aa1p6ffe1().b[37][0]++, columns) || (cov_aa1p6ffe1().b[37][1]++, section.columns),
    aspectRatio: (cov_aa1p6ffe1().b[38][0]++, aspectRatio) || (cov_aa1p6ffe1().b[38][1]++, section.aspectRatio),
    randomOrder: (cov_aa1p6ffe1().b[39][0]++, randomOrder) || (cov_aa1p6ffe1().b[39][1]++, section.randomOrder),
    maxInSlider: (cov_aa1p6ffe1().b[40][0]++, maxInSlider) || (cov_aa1p6ffe1().b[40][1]++, section.maxInSlider),
    maxItemPerPage: (cov_aa1p6ffe1().b[41][0]++, maxItemPerPage) || (cov_aa1p6ffe1().b[41][1]++, section.maxItemPerPage),
    showOccurrences: (cov_aa1p6ffe1().b[42][0]++, classifyBy === 'DATE') || (cov_aa1p6ffe1().b[42][1]++, classifyBy === 'DAY'),
    waitingListEnabled: waitingListEnabled,
    showDescription: (cov_aa1p6ffe1().b[43][0]++, displayDescPreview) || (cov_aa1p6ffe1().b[43][1]++, section.displayDescPreview),
    showPrice: (cov_aa1p6ffe1().b[44][0]++, displayPriceInfo) || (cov_aa1p6ffe1().b[44][1]++, section.displayPriceInfo),
    displayActionBtn: (cov_aa1p6ffe1().b[45][0]++, displayActionBtn) || (cov_aa1p6ffe1().b[45][1]++, section.displayActionBtn),
    currencyCode: currencyCode,
    isSignedIn: isSignedIn,
    classifyBy: classifyBy,
    showDate: showDate,
    showTime: showTime,
    sectionCode: code,
    loading: section.LOADING,
    onActionClick: onActionClick,
    hideShowMoreButton: hideShowMoreButton,
    sortByDate: section.sortByDate,
    reportData: reportData,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    onWatchStreamOnline: onWatchStreamOnline,
    replaceProductNameByPerformance: replaceProductNameByPerformance,
    resaleAvailability: resaleAvailability,
    actionButtonVariant: actionButtonVariant,
    fullWidthActionButtonBreakpoint: fullWidthActionButtonBreakpoint,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 337,
      columnNumber: 15
    }
  })))));
};
cov_aa1p6ffe1().s[46]++;
Section.propTypes = {
  /** The section object to display */
  section: _section.default.isRequired,
  /** The custom section name */
  customSectionName: _propTypes.default.shape({
    defaultMessage: _propTypes.default.string,
    id: _propTypes.default.string
  }),
  /** Override the aspect ratio of images defined in the section values  */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /** Override the randomOrder value defined in the section  */
  randomOrder: _propTypes.default.bool,
  /** Override the columns number value defined in the section  */
  columns: _propTypes.default.number,
  /** Override the columns number value defined in the section  */
  maxInSlider: _propTypes.default.number,
  /** Override the columns number value defined in the section  */
  layout: _propTypes.default.oneOf(['CARD', 'SLIDER', 'DEFAULT', 'PAGINATED_LIST', 'LIST']),
  /** show the subscription link if no availability */
  waitingListEnabled: _propTypes.default.bool,
  /** Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string,
  /** Maximum items to display each time clicking on load more button */
  maxItemPerPage: _propTypes.default.number,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /** to show the date of a product card */
  showDate: _propTypes.default.bool,
  /** to show the time of a product card */
  showTime: _propTypes.default.bool,
  /** Option to show the action buttons or not */
  displayActionBtn: _propTypes.default.bool,
  /** Option to show price info */
  displayPriceInfo: _propTypes.default.bool,
  /** Option to show product description */
  displayDescPreview: _propTypes.default.bool,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /** Option to hide show more button */
  hideShowMoreButton: _propTypes.default.bool,
  /** Option to display a chevron and allow expand/collapse action */
  onCollapse: _propTypes.default.func,
  /** Option to display the expand or collapse the section  */
  collapsed: _propTypes.default.bool,
  /* Contain data for handle display and action for report management */
  reportData: _propTypes.default.shape(_productList.ReportManagementDataType),
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  replaceProductNameByPerformance: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  /** theme context */
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType,
  /** product actions */
  actionButtonVariant: _button.ButtonVariantType,
  /** number of column that action buttons not expand full width */
  fullWidthActionButtonBreakpoint: _propTypes.default.number
};
cov_aa1p6ffe1().s[47]++;
Section.defaultProps = {
  customSectionName: null,
  aspectRatio: null,
  randomOrder: false,
  columns: null,
  maxInSlider: null,
  layout: undefined,
  waitingListEnabled: null,
  currencyCode: null,
  maxItemPerPage: null,
  isSignedIn: false,
  displayActionBtn: false,
  displayPriceInfo: false,
  displayDescPreview: false,
  onActionClick: null,
  hideShowMoreButton: false,
  onCollapse: null,
  collapsed: false,
  showDate: true,
  showTime: true,
  reportData: {},
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {},
    useGA4: false
  },
  isLandingPage: false,
  onWatchStreamOnline: null,
  replaceProductNameByPerformance: false,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  actionButtonVariant: _button.ButtonVariant.primary,
  fullWidthActionButtonBreakpoint: Infinity
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(Section));